import initCounter from '../services/counter';

const MIN_VALUE = 100;
const MAX_VALUE = 1000;
const STEP_VALUE = 50;

initCounter({
  step: STEP_VALUE,
  min: MIN_VALUE,
  max: MAX_VALUE,
  $container: document.querySelector('.js-counter')
});
